import React, { useEffect, useState } from "react";
import { fetchNotices } from "../http";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";

const NoticesPage = () => {
  const history = useHistory();
  const [notices, setNotices] = useState();

  useEffect(() => {
    const loadNotices = async () => {
      try {
        const response = await fetchNotices();
        setNotices(response.data);
      } catch (error) {
        console.error("Error fetching notices:", error);
      }
    };

    loadNotices();
  }, []);

  return (
    <>
      {notices ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Notices</h4>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-md center-text">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Content</th>
                    <th>Created Date</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>

                <tbody className="sidebar-wrapper">
                  {notices?.map((notice, idx) => (
                    <tr
                      key={notice._id}
                      className="hover-effect"
                      onClick={() => history.push(`/notice/${notice._id}`)}>
                      <td>{idx + 1}</td>
                      <td>{notice.title}</td>
                      <td>{notice.content}</td>
                      <td>{new Date(notice.createdAt).toLocaleDateString()}</td>
                      <td>{new Date(notice.updatedAt).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default NoticesPage;
